import { getUnitMarkupFromCapabilityVariable } from '@metservicedev/cf-units';

const filterDatasetsAndCapabilities = ({ databilities, databilityId, datasets }) => {
    const wholeDatability = databilities.find((d) => d.id == databilityId);
    const wholeDataset = wholeDatability
        ? datasets.find((d) => d && d.datasetId === wholeDatability.datasetId && d.capabilityId === wholeDatability.capabilityId)
        : null;
    const wholeCapability = (!!wholeDataset && wholeDataset.capability) || null;
    const capUnit = (!!wholeCapability && getUnitMarkupFromCapabilityVariable(wholeCapability)) || '';
    return { wholeDataset, wholeCapability, capUnit };
};

export default filterDatasetsAndCapabilities;
